import React from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {PolicyFamilyTree, FamilyItem} from './PolicyFamilyTree'

interface Props {
  isOpen: boolean
  onClose: () => void
  items: FamilyItem[]
  currentPk: number
}

export const ModalPolicyFamily: React.FC<Props> = ({isOpen, onClose, items, currentPk}) => {
  const navigate = useNavigate()

  const handleNavigate = (pk: number) => {
    onClose()
    navigate(`/one-policy/${pk}`)
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Related Policies ({items.length})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='text-muted mb-3' style={{fontSize: '0.875rem'}}>
          All policies linked to the same origin. Click any to navigate to it.
        </p>
        <PolicyFamilyTree items={items} currentPk={currentPk} onNavigate={handleNavigate} />
      </Modal.Body>
    </Modal>
  )
}
